// The brand mark. A radar glyph, hand-drawn SVG (no emoji, no icon font), in the skin's brand token.
export function Mark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="10" stroke="var(--brand)" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="6" stroke="var(--brand)" strokeWidth="1.5" opacity="0.6" />
      <circle cx="12" cy="12" r="2" fill="var(--brand)" />
      <path d="M12 12 L19 5" stroke="var(--brand)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}
